import PropTypes from "prop-types";
import React from "react";
import { UserContextSelectors } from "../../redux/selectors";
import { useSelector } from "react-redux";
import { loadSecondaryMenuComponent } from "./loader";
import { PageContextUtils } from "../../utils";

const getSecondaryMenu = (brandId, trackingInfo) => {
  const { name } = PageContextUtils.getClientProviderData();

  const SecondaryMenu = loadSecondaryMenuComponent(brandId, name);

  return SecondaryMenu && <SecondaryMenu trackingInfo={trackingInfo} />;
};

const SecondaryMenu = ({ trackingInfo }) => {
  const brandId = useSelector(UserContextSelectors.brandId);
  return getSecondaryMenu(brandId, trackingInfo);
};

SecondaryMenu.propTypes = {
  brandId: PropTypes.number,
  trackingInfo: PropTypes.object
};

export default React.memo(SecondaryMenu);
